'use strict';

// eslint-disable-next-line require-jsdoc
function displayModalMessage(message, imageClose) {
    // var imageClose = document.getElementById('image_close').getAttribute('src');
    $('body').removeClass('is-open');
    $('body').append('<div class="cart_modal_bg"></div>').fadeIn();
    $('#maincontent').append(
        '<div class="modal modal_error" id="modal_error">' +
        '<p><a class="modal_error_close">' +
        '<img src="' + imageClose + '" alt="close">' +
        '</a></p>' +
        '<p class="modal_error__text">' + message + '</p></div>').hide().fadeIn(200);;
    $('#modal_error').css('display', 'block');
    $('#cart_modal_box').css('display', 'none');
    $('#modal_error').modal('show');
    $('body').removeClass('modal-open');
}

module.exports.displayModalMessage = displayModalMessage;
